import RTableLayout from "../../../layout/RTableLayout";
import {CFlex, DText, Flex, Row} from "../../../../../styles/CommonStyles";
import Operation from "../../../../common/utils/Operation";
import {useNavigate} from "react-router-dom";
import Text from "../../../../../core/utils/Text";
import BooleanIcon from "../../../../common/utils/BooleanIcon";


const RWorkspaceTable = ({data}) => {

    const navigate = useNavigate()
    const { data: workspaces } = data
    const onDetailsClicked = (workspace) => navigate(`/reports/workspace/${workspace._id}`)

    return (
        <RTableLayout
            data={data}
        >
            {workspaces?.data?.map((item, idx) => (
                <Row key={item._id} index={idx} cs={'50% 50%'}>
                    <div />
                    <Flex justify={'flex-end'}>
                        <Operation
                            onDetailsClicked={() => onDetailsClicked(item)}
                            hasDetails
                        />
                    </Flex>
                    <CFlex align={'flex-start'} justify={'space-around'} height={'120px'}>
                        <DText fontSize={'ss'} main>
                            <Text tid={'name'} /> :
                        </DText>
                        <DText fontSize={'ss'} main>
                            <Text tid={'code'} /> :
                        </DText>
                        <DText fontSize={'ss'} main>
                            <Text tid={'is-verified'} /> :
                        </DText>
                        <DText fontSize={'ss'} main>
                            <Text tid={'is-active'} /> :
                        </DText>
                    </CFlex>
                    <CFlex align={'flex-start'} justify={'space-around'} height={'120px'}>
                        <DText fontSize={'ss'} primary>
                            {item.name}
                        </DText>
                        <DText fontSize={'ss'} primary>
                            {item.code}
                        </DText>
                        <BooleanIcon bool={item.isVerified} />
                        <BooleanIcon bool={item.isActive} />
                    </CFlex>
                </Row>
            ))}
        </RTableLayout>
    )
}


export default RWorkspaceTable
